/* eslint-disable react/prefer-stateless-function */
import React, { useRef, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import { useLazyQuery, useMutation, useQuery } from 'react-apollo';
import OfferListing from './OfferListing';
import Header from '../../header/Header';
import { GET_OFFER_LIST_QUERY, GET_UNSEEN_MESSAGES } from '../../../../graphql-client/queries';
import { REMOVE_OFFER, LOADER_MUTATION } from '../../../../graphql-client/mutations';
import { NUMERIC_VALUE, staticConstants } from '../../../../utils';

function OfferListingContainer() {
  const { addToast } = useToasts();
  const location = useLocation();
  const headerRef = useRef();
  const [queryObj, setQueryObj] = useState({ page: 1, limit: NUMERIC_VALUE.FIVE });
  const [isSearchKey, setSearchKey] = useState('');
  const [isCampaignFilter, setIsCampaignFilter] = useState();
  const [isAudienceFilter, setIsAudienceFilter] = useState();
  const [isExcludeExpiredOffer, setIsExcludeExpiredOffer] = useState(false);
  const [isUnreadMessage, setIsUnreadMessage] = useState(false);
  const { data: unreadConversations } = useQuery(GET_UNSEEN_MESSAGES);

  const [currentPage, setCurrentPage] = useState(1);
  const [loaderValue, setLoaderValue] = useState(false);
  const [offerId, setOfferId] = useState();

  const [getOfferList, { loading, data: offerData, refetch: refreshList }] = useLazyQuery(
    GET_OFFER_LIST_QUERY,
    {
      variables: queryObj,
      fetchPolicy: 'cache-and-network',
    },
  );
  const appliedOfferFilter = JSON.parse(localStorage.getItem('appliedOfferFilter'));

  useEffect(() => {
    if (appliedOfferFilter) {
      setQueryObj(appliedOfferFilter);
    }
    getOfferList();
  }, []);

  const [loader] = useMutation(LOADER_MUTATION, {
    variables: { show: loaderValue },
  });
  const [removeOffer] = useMutation(REMOVE_OFFER, {
    variables: {},

    onError(error) {
      setLoaderValue(false);
      loader();
      addToast(error.message || error.graphQLErrors[0].message, { appearance: 'error' });
    },

    onCompleted(data) {
      setLoaderValue(false);
      loader();
      addToast(data.removeOffer.message, { appearance: 'success' });
      setCurrentPage(1);
      refreshList({
        searchKey: isSearchKey,
        page: 1,
        limit: NUMERIC_VALUE.FIVE,
        campaign: isCampaignFilter,
        audience: isAudienceFilter,
        isExcludeExpiredOffer,
        isUnreadMessage,
      });
      setSearchKey(isSearchKey);
    },
  });

  useEffect(() => {
    offerId && removeOffer({ variables: { offerId } });
  }, [offerId]);

  const deleteOffer = (selectedOfferId) => {
    setOfferId(selectedOfferId);
  };

  const searchRecord = (searchKey, offerFilter) => {
    const audience = [];
    const campaign = [];
    let isExcludeExpiredOfferFilter = false;
    let isUnreadMessageFilter = false;
    if (offerFilter.length) {
      offerFilter.filter((value) => {
        if (value === staticConstants.STATUS_TYPE.PUBLIC || value === staticConstants.STATUS_TYPE.PRIVATE
          || value === staticConstants.STATUS_TYPE.AFFILIATE
        ) {
          audience.push(value);
        } else if (value === staticConstants.STATUS_TYPE.EXPIRED_OFFER) {
          isExcludeExpiredOfferFilter = true;
        } else if (value === staticConstants.STATUS_TYPE.UNREAD_MESSAGE_OFFER) {
          isUnreadMessageFilter = true;
        } else {
          campaign.push(value);
        }
      });
    }

    const filterObj = {
      searchKey,
      page: 1,
      limit: NUMERIC_VALUE.FIVE,
      campaign,
      audience,
      isExcludeExpiredOffer: isExcludeExpiredOfferFilter,
      isUnreadMessage: isUnreadMessageFilter,
    };

    refreshList(filterObj);
    localStorage.setItem('appliedOfferFilter', JSON.stringify(filterObj));
    setCurrentPage(1);
    setSearchKey(searchKey);
    setIsCampaignFilter(campaign);
    setIsAudienceFilter(audience);
    setIsExcludeExpiredOffer(isExcludeExpiredOfferFilter);
    setIsUnreadMessage(isUnreadMessageFilter);
  };

  const infiniteScroll = (page, limit) => {
    setCurrentPage(page);
    refreshList({
      searchKey: isSearchKey,
      page,
      limit,
      campaign: isCampaignFilter,
      audience: isAudienceFilter,
      isExcludeExpiredOffer,
      isUnreadMessage,
    });
  };
  const hasUnreadOfferMessage = (messageOfferId) => {
    if (unreadConversations) {
      return unreadConversations.unseenMessages.find((el) => el.unseenMessage
                   && el.offerId === messageOfferId);
    }
    return null;
  };
  return (
    <>
      <div className="content-wrapper">
        <Header
          search={searchRecord}
          ref={headerRef}
          pathName={location.pathname}
          count={offerData && offerData.offerList && offerData.offerList.count}
        />
        <OfferListing
          offerData={offerData && offerData.offerList}
          loading={loading}
          handleInfiniteScroll={infiniteScroll}
          currentPage={currentPage}
          onDeleteOfferCallback={deleteOffer}
          hasUnreadMessage={hasUnreadOfferMessage}
          isSearchApplied={!!isSearchKey}
        />
      </div>

    </>
  );
}

export default OfferListingContainer;
